import { Outlet } from "react-router-dom";

export default function Users() {
	return (
		<div className='users-page page'>
			<Outlet />
		</div>
	);
}
